import { createAction, props } from '@ngrx/store';

import { PcgEntry } from '@models/pcg-entry';

export const LOAD = '[PcgEntries] Load';
export const UPDATE = '[PcgEntries] Update';
export const ADD = '[PcgEntries] Add';

export const load = createAction(LOAD);
export const update = createAction(UPDATE, props<{ pcgEntries: PcgEntry[] }>());
